import { Chip, Typography } from "@mui/material";
import { UNKNOWN_LABEL_FILTER_VALUE } from "components/manualReview/filters/eventFilters";
import { useTenantTranslation } from "hooks/formatters";
import { useMaterialColor } from "hooks/useMaterials";

export const UnknownChip = ({
  selected,
  onClick,
}: {
  selected: boolean;
  onClick: () => void;
}) => {
  const { t } = useTenantTranslation();
  const { getColor } = useMaterialColor();
  const color = getColor(UNKNOWN_LABEL_FILTER_VALUE);

  return (
    <Chip
      label={
        <Typography
          variant="body2"
          sx={{
            fontWeight: selected ? 600 : 400,
            color: selected ? "white" : "black",
          }}
        >
          {t("unknown").toUpperCase()}
        </Typography>
      }
      onClick={onClick}
      sx={{
        backgroundColor: selected ? color : `${color}40`,
        borderColor: color,
        borderWidth: 2,
        borderStyle: "solid",
        cursor: "pointer",
        transition: "all 0.2s ease",
        "&:hover": {
          backgroundColor: selected ? color : `${color}80`,
          transform: "scale(1.05)",
        },
      }}
    />
  );
};
